import React, {useEffect, useState} from "react";

import {useDispatch, useSelector} from "react-redux";
import usePermissions from "../../hooks/usePermissions";
import {useNavigate} from "react-router-dom";
import {
    clearCrmSystems,
    deleteCrmSystem,
    getCrmSystem,
    getCrmSystems,
    modalCrmSystem
} from "../../store/crmSystems/actions";
import {Col, Container, Row} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import NoSearchResult from "../../components/Common/NoSearchResult";
import {ICrmSystem} from "../../store/crmSystems/types";
import ListCrmSystems from "./components/ListCrmSystems";
import ModalCrmSystems from "./components/ModalCrmSystems";
import ServerPagination from "../../components/Common/ServerPagination";

const CrmSystems: React.FC = () => {
    document.title = "CRM Systems | Dashboard";
    const {hasPermission} = usePermissions();

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const data = useSelector((state: any) => (state.CrmSystem.data || []) as ICrmSystem[]);
    const pagination = useSelector((state: any) => state.CrmSystem.pagination || {});
    const loading = useSelector((state: any) => state.CrmSystem.loading || false);
    const isOpenModal = useSelector((state: any) => state.CrmSystem.isOpenModal || false);

    const [filter, setFilter] = useState({per_page: 9, page: 1, sort_key: "id", sort_order: "desc", q: ""});

    const updateFilter = (changes: Partial<typeof filter>) => {
        setFilter((prevFilter) => ({...prevFilter, ...changes}));
    };

    useEffect(() => {
        dispatch(getCrmSystems('', filter))

        return () => {
            dispatch(clearCrmSystems())
        };
    }, [dispatch, filter]);

    useEffect(() => {
        const permission = hasPermission('view-crm-system');
        if (!permission) {
            navigate('/no-access');
        }
    }, [hasPermission, navigate]);

    const handleCrmSystemAddClick = () => {
        dispatch(modalCrmSystem(true))
    }

    const handleCrmSystemUpdate = (id: number) => {
        dispatch(getCrmSystem(id))
    }

    const handleCrmSystemDelete = (id: number) => {
        dispatch(deleteCrmSystem(id))
    }

    return (
        <div className="page-content">
            <Container fluid>
                {/* Render Breadcrumbs */}
                <Breadcrumbs title="Dashboard" breadcrumbItem="CRM Systems"/>

                {hasPermission("create-crm-system") &&
                    <Row className="align-items-center">
                        <Col md={12}>
                            <div className="d-flex flex-wrap align-items-center justify-content-end gap-2 mb-3">
                                <button type="button" className="btn btn-light" onClick={handleCrmSystemAddClick}>
                                    <i className="bx bx-plus me-1"></i> Add New
                                </button>
                            </div>
                        </Col>
                    </Row>}

                <Row>
                    {data?.length > 0 && <ListCrmSystems crmSystems={data} onUpdate={handleCrmSystemUpdate}
                                                         onDelete={handleCrmSystemDelete}/>}

                    {!loading && data?.length === 0 && (<NoSearchResult/>)}
                    {loading && (<NoSearchResult text="Loading..."/>)}

                    {pagination.total_page > 1 && (
                        <ServerPagination totalPages={pagination.total_page}
                                          page={pagination.current_page}
                                          onChange={(page) => updateFilter({page})}/>
                    )}
                </Row>

                {isOpenModal && <ModalCrmSystems isOpen={isOpenModal}/>}
            </Container>
        </div>
    )
}

export default CrmSystems;